<template>
  <section class="relative flex min-h-[80vh] items-center overflow-hidden bg-white pt-24 pb-16 md:pt-32 md:pb-20">
    <div class="paw-pattern pointer-events-none absolute inset-0 opacity-[0.35]" aria-hidden="true" />

    <div class="relative mx-auto w-full max-w-6xl px-4 md:px-6">
      <div class="grid gap-12 lg:grid-cols-2 lg:gap-16 lg:items-center">

        <!-- Left: copy + CTAs -->
        <div>
          <h1 class="text-5xl font-bold leading-[1.05] tracking-tight text-foreground md:text-6xl lg:text-7xl">
            {{ $ts('hero.title') }}
            <span class="block text-vet">{{ $ts('hero.titleHighlight') }}</span>
          </h1>
          <p class="mt-6 max-w-md text-lg text-muted-foreground md:text-xl">
            {{ $ts('hero.description') }}
          </p>

          <div class="mt-10 flex flex-col gap-4 sm:flex-row">
            <NuxtLink :to="$localeRoute('/vet/signup')">
              <button class="inline-flex h-14 items-center gap-2 rounded-full bg-foreground px-8 text-base font-semibold text-background transition-opacity hover:opacity-80">
                {{ $ts('hero.cta') }}
                <Icon name="tabler:arrow-right" size="18" />
              </button>
            </NuxtLink>
            <button
              class="inline-flex h-14 items-center gap-2 rounded-full border border-border/60 bg-white px-8 text-base font-semibold text-foreground transition-colors hover:bg-muted/60"
              @click="scrollToHowItWorks"
            >
              {{ $ts('hero.learnMore') }}
              <Icon name="tabler:chevron-down" size="18" class="opacity-60" />
            </button>
          </div>

          <!-- Stats -->
          <div class="mt-10 flex flex-wrap gap-6 border-t border-border/40 pt-8">
            <div>
              <div class="text-2xl font-bold text-foreground">{{ $ts('hero.stats.waitTimeValue') }}</div>
              <div class="mt-0.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{{ $ts('hero.stats.waitTime') }}</div>
            </div>
            <div>
              <div class="text-2xl font-bold text-foreground">{{ $ts('hero.stats.availabilityValue') }}</div>
              <div class="mt-0.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{{ $ts('hero.stats.availability') }}</div>
            </div>
            <div>
              <div class="text-2xl font-bold text-foreground">{{ $ts('hero.stats.happyPetsValue') }}</div>
              <div class="mt-0.5 text-xs font-semibold uppercase tracking-widest text-muted-foreground">{{ $ts('hero.stats.happyPets') }}</div>
            </div>
          </div>
        </div>

        <!-- Right: chat preview card -->
        <div class="flex justify-center lg:justify-end">
          <ChatPreview />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '#imports';
import ChatPreview from '#components/vet/ChatPreview.vue';

const { $ts, $localeRoute } = useI18n();

function scrollToHowItWorks() {
  document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
}
</script>
